import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { DisciplinaService } from '../../services/disciplina-service';
import { Disciplina } from '../../models/disciplina';
import { ToastrService } from 'ngx-toastr';
import { Prova, Questao } from '../../models/prova';
import { ProvaService } from '../../services/prova-service';
import { Curso } from '../../models/curso';
import { CursoService } from '../../services/curso-service';

@Component({
  selector: 'app-prova',
  templateUrl: './prova.component.html',
  styleUrls: ['./prova.component.scss']
})
export class ProvaComponent implements OnInit {

  insertForm: FormGroup;
  disciplinasAll: Disciplina[] = [];
  disciplinas: Disciplina[] = [];
  prova: Prova;
  questao: Questao;
  questoes: Questao[] = [];
  provasPai: Prova[] = [];
  cursos: Curso[] = [];
  constructor(public fb: FormBuilder, public disciplinaService: DisciplinaService,
              private toastr: ToastrService, public provaService: ProvaService, public cursoService: CursoService) {

    this.disciplinaService.getSnapshot().then(res => {
      res.forEach(d => {
        let disciplina = new Disciplina();
        disciplina = d.val();
        disciplina.id = d.key;
        this.disciplinasAll.push(disciplina);
      });
      this.disciplinasAll.sort((a, b) => a.name < b.name ? -1 : 1);
    });

    this.cursoService.getSnapshot().then(res => {
      res.forEach(c => {
        let curso = new Curso();
        curso = c.val();
        curso.id = c.key;
        this.cursos.push(curso);
      });
      this.cursos.sort((a, b) => a.name < b.name ? -1 : 1);
    });


    this.insertForm = fb.group({
      nomeProva: [null, [Validators.required]],
      disciplina: [-1],
      curso: [-1],
      resposta: [null],
      descricao: [null],
      a: [null],
      b: [null],
      c: [null],
      d: [null],
      dependeProva: [-1]
    });
  }

  ngOnInit() {

  }

  build() {
    this.prova = new Prova();
    this.prova.nomeProva = this.insertForm.controls['nomeProva'].value;
    this.prova.disciplinaId = this.insertForm.controls['disciplina'].value;
    this.prova.dependeProva = this.insertForm.controls['dependeProva'].value;
    if (this.prova.dependeProva === '-1') {
      this.prova.dependeProva = null;
    }
  }

  buildQuestao() {
    this.questao = new Questao();
    this.questao.descricao = this.insertForm.controls['descricao'].value;
    this.questao.a = this.insertForm.controls['a'].value;
    this.questao.b = this.insertForm.controls['b'].value;
    this.questao.c = this.insertForm.controls['c'].value;
    this.questao.d = this.insertForm.controls['d'].value;
    this.questao.resposta = this.insertForm.controls['resposta'].value;
  }



  trocarDisciplina(teste) {
    this.provasPai = [];
    this.disciplinaService.getProvas(teste).then(res => {
      res.forEach((res) => {
        const prova = new Prova();
        prova.nomeProva = res.val().nomeProva;
        prova.id = res.key;
        this.provasPai.push(prova);
      });
    });
  }

  trocarCurso(teste) {
    this.disciplinas = [];
    this.insertForm.patchValue({ disciplina: -1});
    for (const x in this.disciplinasAll) {
      if (this.disciplinasAll[x].curso && teste === this.disciplinasAll[x].curso.toString()) {
        this.disciplinas.push(this.disciplinasAll[x]);
      }
    }

    this.disciplinas.sort((a, b) => a.name < b.name ? -1 : 1);
  }

  clear() {
    this.clearQuestao();
    this.provasPai = [];
    this.insertForm.patchValue({
      nomeProva: null,
      disciplina: -1,
      dependeProva: -1
    });
  }

  clearQuestao() {
    this.insertForm.patchValue({
      descricao: null,
      a: null,
      b: null,
      c: null,
      d: null,
      resposta: null
    });
  }

  adicionarQuestao() {
    this.buildQuestao();
    if (!this.questao.descricao || this.questao.descricao.trim().length === 0) {
      this.toastr.error('Você deve informar o texto da questão');
      return;
    }
    if (!this.questao.a || this.questao.a.trim().length === 0) {
      this.toastr.error('Você deve informar a alternativa A');
      return;
    }
    if (!this.questao.b || this.questao.b.trim().length === 0) {
      this.toastr.error('Você deve informar a alternativa B');
      return;
    }
    if (!this.questao.c || this.questao.c.trim().length === 0) {
      this.toastr.error('Você deve informar a alternativa C');
      return;
    }
    if (!this.questao.d || this.questao.d.trim().length === 0) {
      this.toastr.error('Você deve informar a alternativa D');
      return;
    }
    if (!this.questao.resposta) {
      this.toastr.error('Você deve informar a resposta da questão');
      return;
    }
    this.questoes.push(this.questao);
    this.clearQuestao();
    // console.log(this.questao)
  }

  save() {
    this.build();
    const d = this.prova.disciplinaId;
    if (!d || d === '-1' || parseInt(d) === -1) {
      this.toastr.error('Você deve informar a disciplina dessa prova');
      return;
    }

    if (!this.prova.nomeProva || this.prova.nomeProva.trim().length === 0) {
      this.toastr.error('Você deve informar um nome para a prova');
      return;
    }

    if (this.questoes.length === 0) {
      this.toastr.error('Você deve cadastrar pelo menos uma questão');
      return;
    }
    this.prova.questoes = this.questoes;
    this.provaService.insert(this.prova).then((res) => {
      this.toastr.success('Prova cadastrada com sucesso.');
      this.clear();
      this.questoes = [];
      return;
    });


  }

}
